export default "__VITE_ASSET__v_lRFh34__"